const routeConfig = require("./route-config");
const Token = require('common/lib/util/token').default;
const md5 = require('blueimp-md5');

/*
  This method replicates the private routing logic in Backbone.js
 */
const routeToRegexp = function(route) {
  route = route.replace(/[\-{}\[\]+?.,\\\^$|#\s]/g, '\\$&')
    .replace(/\((.*?)\)/g, '(?:$1)?')
    .replace(/(\(\?)?:\w+/g, function(match, optional) {
      return optional ? match : '([^/?]+)';
    })
    .replace(/\*\w+/g, '([^?]*?)');
  return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
};


export default new class Interceptor {
  _controller = null;
  _gamma = null;
  _compiledConfig = routeConfig.map((config) => {
    return {
      ...config,
      match: (config.match || []).map(routeToRegexp)
    }
  });

  setController(controller) {
    this._controller = controller;
  }

  setGamma(gamma) {
    this._gamma = gamma;
  }

  hideGamma() {
    $('#root').css({ display: 'none' });

    if (!this._gamma) {
      return;
    }

    this._gamma.unmount();
    this._gamma = null
  }

  navigateToGamma(path) {
    $('.header-logo').addClass('is-throbbing');
    this._controller.clearPreviousView(true);
    window.history.pushState({}, '', path);
  }

  navigateToClassic() {
    this._controller.clearPreviousView();
  }

  isGammaRoute(path) {
    let config = this._compiledConfig.find((config) => config.match.find((rxp) => rxp.test(path)));
    if (config) {
      const {audience, allocation, name} = config;

      let override = localStorage.getItem('routeConfig');
      if (override) {
        let overrides = override.split(",").map((a) => a.trim());
        if (overrides.includes(name)) {
          return true;
        }
      }

      if (audience) {
        const audiences = Array.isArray(audience) ? audience : [audience];
        const matchesAll = audiences.every(() => {
          if (audience === 'notLoggedIn') {
            return !Token.getMyId();
          } else {
            console.error(`Unknown audience in single-spa interceptor: ${audience}`);
            return false;
          }
        });
        if (!matchesAll) {
          return false
        }
      }

      if (allocation) {
        const myId = Token.getMyId() || 'notLoggedIn';
        const bucket = parseInt(md5(`${name}for${myId}`).slice(0, 8), 16) % 1000;
        return bucket <= allocation * 1000;
      }
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./app/scripts/singlespa/interceptor.js